<template>
  <div>
    <div class="five_step_box mb-20" v-if="true">
      <fiveStep :step="1" :key="freshKey"></fiveStep>
    </div>
    <div class="exercise_consolidation p-20">
      <div v-if="!showFinishHomework">
        <div class="flex FlexBetween Flexalign">
          <div class="exercise-title">· 习题巩固</div>
          <div class="flex Flexalign">
            <div class="btn_previous btn_next cursor_pointer" @click="previoustep">
              上一步
            </div>
            <div class="btn_next ml-20 cursor_pointer" @click="nextStep">下一步</div>
          </div>
          <!-- <div class="cursor_pointer" @click="showHomework(true)">我完成的作业 ></div> -->
        </div>
        <div class="consolidation_list flex FlexWrap" v-if="consolidationList?.length">
          <div class="consolidation_one flex Flexalign mt-20 px-15" v-for="(item, index) in consolidationList"
            :key="index" :class="[index % 2 == 0 ? 'mr-20' : '']">
            <el-image class="homework_icon" :src="iconPath(
              item.otherRule?.assignmentLabel == 1
                ? 'must_task.png'
                : 'choiceable_task.png'
            )
              "></el-image>
            <div class="hpmework_top_bg_box pl-12" v-if="item.otherRule?.assignmentType == 1">
              <div>测试卷</div>
            </div>
            <div class="consolidation_one_right flex-1 ml-10 flex flexcolumn FlexBetween">
              <div class="toverflow consolidation_one_name">{{ item.examName }}</div>
              <div class="toverflow">{{ item.examDetail }}</div>
              <div class="flex Flexalign FlexjustifyEnd">
                <div v-if="item.deadlineTime">
                  截止时间：剩余 <span class="text_red">{{ item.deadlineTime }}</span> 天
                </div>
                <div class="btn_finish cursor_pointer" @click="toFinish(item)" v-if="item.isCorrect == 0">
                  去完成
                </div>
                <div class="btn_finish cursor_pointer btn_readover btn_resubmit mr-15"
                  v-if="item.isCorrect == 2 && item?.otherRule?.assignmentType == 2" @click="resubmit(item)">
                  重新提交
                </div>
                <div class="btn_finish cursor_pointer btn_readover" v-if="item.isCorrect == 2">
                  待批阅
                </div>
                <div class="btn_finish cursor_pointer btn_readover" v-if="item.isCorrect == 4">
                  ai判分中
                </div>
                <div class="btn_finish cursor_pointer btn_readover" v-if="item.isCorrect == 5">
                  批阅中
                </div>
                <div class="btn_finish cursor_pointer btn_detail" @click="goHomeworkDetail(item)"
                  v-if="item.isCorrect == 1 || item.isCorrect == 3">
                  详情
                </div>
                <!-- <el-image class="homework_finish_icon" :src="iconPath('homework_finish_icon.png')" v-else></el-image> -->
              </div>
            </div>
          </div>
        </div>
        <div v-else>
          <moe-empty url="moe_empty_bg_img.png" emptyText="暂无作业"></moe-empty>
        </div>
      </div>
      <myFinishHomework ref="myFinishHomework" @showHomework="showHomework" v-if="showFinishHomework"
        :homeworkType="'homework'">
      </myFinishHomework>
    </div>
  </div>
</template>

<script>
import myFinishHomework from "./myFinishHomework.vue";
import fiveStep from "./fiveStep.vue";
import { mapState } from "vuex";
export default {
  name: "GjkcH5ExerciseConsolidation",

  components: { myFinishHomework, fiveStep },
  computed: {
    ...mapState({
      selectLearningInfo: (state) => state.learning.selectLearningInfo,
      courseRound: (state) => state.learning.courseRound,
    }),
  },
  inject: [
    "practiceBack",
    "updateShowPractice",
    "showWrongQuestion",
    "showCustomizeHomework",
  ],

  data() {
    return {
      consolidationList: [],
      showFinishHomework: false,
      listQuery: {
        chapterId: "",
        schemeId: "",
        roundId: "",
        examScenes: [3],
        phaseId: "",
      },
      freshKey: 1,
    };
  },

  mounted() {
    this.getMyHomeworkList();
  },

  methods: {
    // 上一步（没有上一章节阶段）
    previoustep() {
      this.$store.commit("learning/setStudyPreviousStep", 2);
    },
    nextStep() {
      this.$store.commit("learning/setStudyStepInfo", 2);
    },
    getBackImage() {
      return {
        backgroundImage: this.iconPath("hpmework_top_bg.png"),
      };
    },
    showHomework(flag) {
      this.freshKey++;
      this.showFinishHomework = flag;
      setTimeout(() => {
        if (this.$refs.myFinishHomework) {
          this.$refs.myFinishHomework.stage = 2;
        }
      }, 200);
      this.getMyHomeworkList();
    },
    // 去完成
    toFinish(info) {
      this.showFinishHomework = true;
      let stage = 1;
      if (info.otherRule?.assignmentType == 2) {
        stage = 3;
      }
      setTimeout(() => {
        this.$refs.myFinishHomework.stage = stage;
        this.$refs.myFinishHomework.paperInfo = info;
      }, 200);
    },
    // 重新提交
    resubmit(info) {
      this.showFinishHomework = true;
      setTimeout(() => {
        this.$refs.myFinishHomework.stage = 3;
        this.$refs.myFinishHomework.paperInfo = info;
      }, 200);
    },
    getMyHomeworkList() {
      if (this.$Tools.empty(this.selectLearningInfo)) return;
      this.listQuery.chapterId = this.selectLearningInfo?.chapterId;
      this.listQuery.schemeId = this.selectLearningInfo?.schemeId;
      this.listQuery.roundId = this.selectLearningInfo?.roundId;
      this.listQuery.phaseId = this.selectLearningInfo?.id;
      this.$Api.course
        .getMyHomeworkList(this.listQuery)
        .then((res) => {
          this.consolidationList = res.data.data;
        })
        .catch(() => { });
    },
    // 详情
    goHomeworkDetail(info) {
      if (info.otherRule?.assignmentType == 2) {
        // 获取自定义作业
        this.$Api.exam
          .getCustomizeHomeworkRecordInfo(info.recordId)
          .then((res) => {
            this.showCustomizeHomework(true, res.data.data, true);
          })
          .catch(() => { });
      } else {
        // 获取作业试卷
        this.$Api.exam
          .getPaperRecordInfo(info.recordId)
          .then((res) => {
            this.showWrongQuestion(true, res.data.data, false, true);
          })
          .catch(() => { });
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.exercise_consolidation {
  width: 762px;
  background: #ffffff;
  border-radius: 10px;
  box-sizing: border-box;
  font-size: 14px;
  color: #111111;

  .exercise-title {
    font-size: 18px;
    font-weight: 600;
  }

  .btn_next {
    width: 69px;
    height: 30px;
    line-height: 30px;
    background: linear-gradient(97deg, #00d498 0%, #00d5c2 100%);
    border-radius: 18px;
    text-align: center;
    color: #fff;
  }

  .btn_previous {
    background: none;
    border: 1px solid #909090;
    color: #909090;
  }

  .consolidation_list {
    .consolidation_one {
      width: 351px;
      height: 120px;
      background: #ffffff;
      box-shadow: 0px 0px 12px 0px rgba(0, 0, 0, 0.08);
      border-radius: 10px;
      box-sizing: border-box;
      position: relative;

      .homework_icon {
        width: 80px;
        height: 80px;
      }

      .hpmework_top_bg_box {
        width: 67px;
        height: 29px;
        // text-align: center;
        line-height: 29px;
        background-image: url(../../../../public/static/icon/hpmework_top_bg.png);
        font-size: 12px;
        color: #ffffff;
        background-size: 100% 100%;
        position: absolute;
        top: -12px;
        right: 0;
      }

      .consolidation_one_right {
        height: 80px;
        max-width: 220px;
        font-size: 12px;
        color: rgb(153, 153, 153);

        .consolidation_one_name {
          font-size: 14px;
          color: #111111;
        }

        .text_red {
          color: RGBA(255, 17, 17, 1);
        }

        .btn_finish {
          width: 61px;
          height: 27px;
          background: linear-gradient(97deg, #00d498 0%, #00d5c2 100%);
          border-radius: 14px;
          text-align: center;
          line-height: 27px;
          color: #ffffff;
          // margin-left: calc(100% - 62px);
        }

        .btn_readover {
          background: #ffb000;
          opacity: 0.36;
        }

        .btn_resubmit {
          border: 1px solid #13d6aa;
          background: none;
          color: #13d6aa;
        }

        .btn_detail {
          background: #357bfe;
        }

        .homework_finish_icon {
          width: 64px;
          height: 64px;
          position: absolute;
          right: 10px;
          bottom: 10px;
        }
      }
    }
  }
}
</style>
